import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { addProductToStock } from "../redux/productsItems/actions";

const ProductInputForm = () => {
  const dispatch = useDispatch();
  const [productName, setProductName] = useState("");
  const [productCategory, setProductCategory] = useState("");
  const [productImg, setProductImg] = useState("");
  const [productPrice, setProductPrice] = useState(0);
  const [productQuantity, setProductQuantity] = useState(0);

  // reset from for reseting product input from ...
  const resetForm = () => {
    setProductName("");
    setProductCategory("");
    setProductImg("");
    setProductPrice(0);
    setProductQuantity(0);
  };

  // Submit handler from ...
  const submitHandler = (e) => {
    e.preventDefault();

    const product = {
      name: productName,
      category: productCategory,
      image: productImg,
      price: productPrice,
      quantity: productQuantity,
      category: productCategory,
    };
    dispatch(addProductToStock(product));
    resetForm();
  };

  return (
    <div className="formContainer">
      <h4 className="formTitle">Add New Product</h4>
      <form
        className="space-y-4 text-[#534F4F]"
        id="lws-addProductForm"
        onSubmit={submitHandler}
      >
        {/* product name  */}
        <div className="space-y-2">
          <label htmlFor="lws-inputName">Product Name</label>
          <input
            className="addProductInput"
            id="lws-inputName"
            type="text"
            value={productName}
            onChange={(e) => setProductName(e.target.value)}
            required
          />
        </div>
        {/* product category  */}
        <div className="space-y-2">
          <label htmlFor="lws-inputCategory">Category</label>
          <input
            className="addProductInput"
            id="lws-inputCategory"
            type="text"
            value={productCategory}
            onChange={(e) => setProductCategory(e.target.value)}
            required
          />
        </div>
        {/* product image url  */}
        <div className="space-y-2">
          <label htmlFor="lws-inputImage">Image Url</label>
          <input
            className="addProductInput"
            id="lws-inputImage"
            type="text"
            value={productImg}
            onChange={(e) => setProductImg(e.target.value)}
            required
          />
        </div>
        {/* price & quantity container  */}
        <div className="grid grid-cols-2 gap-8 pb-4">
          {/* price  */}
          <div className="space-y-2">
            <label htmlFor="ws-inputPrice">Price</label>
            <input
              className="addProductInput"
              type="number"
              id="lws-inputPrice"
              min="0"
              value={productPrice}
              onChange={(e) => setProductPrice(e.target.value)}
              required
            />
          </div>
          {/* quantity  */}
          <div className="space-y-2">
            <label htmlFor="lws-inputQuantity">Quantity</label>
            <input
              className="addProductInput"
              type="number"
              id="lws-inputQuantity"
              min="1"
              value={productQuantity}
              onChange={(e) => setProductQuantity(e.target.value)}
              required
            />
          </div>
        </div>
        {/* submit button  */}
        <button
          type="submit"
          id="lws-inputSubmit"
          className={`submit`}
          disabled={productPrice <= 0 || productQuantity <= 0}
        >
          Add Product
        </button>
      </form>
    </div>
  );
};

export default ProductInputForm;
